import React, { useState, useEffect } from 'react';
import './Video.css';
import { motion } from 'framer-motion';

export default function Video() {
    const words = ['MAINTENANCE', ' &', 'REPAIRS']
    const fadeInUp = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.2,
                duration: 0.5,
                ease: 'easeOut',
            },
        }),
    };
    const bounceUp = {
        hidden: { opacity: 0, y: 100 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                type: 'spring',
                bounce: 0.4,
                duration: 1,
            },
        },
    };

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null)
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('https://admin.ezerautomotive.co.nz/api/maintenance-repair/');
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const result = await response.json();
                setData(result);
                console.log(result, "repair result")
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // console.log(data[0].youtube_url,"dfsf")
    return (
        <div className="video-section">
            <h2 className="video-heading chakra-petch-bold">
                {words.map((word, i) => (
                    <motion.span
                        key={i}
                        custom={i}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={fadeInUp}
                        style={{ display: 'inline-block', marginRight: '0.5rem' }}
                    >
                        {word}
                    </motion.span>
                ))}
            </h2>
            <motion.div
                className="video-bg-section"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                variants={bounceUp}
            >
                <a href={data[0]?.youtube_url} target="_blank" rel="noopener noreferrer">
                    <img src="/assets/video/video-bg2.jpg" alt="Slider" />
                </a>
                {/* <div className="video-embed-container">
                    <iframe
                        src={data[0]?.youtube_url}
                        // src='"https://youtu.be/DOtE-h62Lhw?si=Z4sRzjSFUfU2s0ta"'
                        title="YouTube video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div> */}
                <div className='video-bg-overlay'>
                    <a href="https://youtu.be/DOtE-h62Lhw" target="_blank" rel="noopener noreferrer" className="video-details-link">
                        <span className="video-icon-box">
                            <i className="fa fa-play" aria-hidden="true" style={{ fontSize: '25px' }}></i>
                        </span>
                    </a>
                </div>
            </motion.div>

        </div>
    )
}